{
  "inviteResultDialog": {
    "title": "Invitation results",
    "text": "The invitations couldn't be sent.",
    "text2": "The request validation failed.",
    "text3": "Succeeded:",
    "text4": " items",
    "text5": "Failed:",
    "text6": "Failed email addresses"
  },
  "userAreaCameraPopover": {
    "title": "Areas and cameras viewable by {{userEmail}}"
  },
  "userEditDialog": {
    "email": "Email address",
    "firstName": "Name",
    "firstNameKana": "Name (phonetic)",
    "roleId": "Role",
    "assignedSiteIds": "Assigned areas",
    "permittedSiteIds": "Area view permissions",
    "permittedCameraIds": "Camera permissions",
    "text": "The user information couldn't be updated.",
    "text2": "Editing this user isn't permitted.",
    "text3": "The user wasn't found.",
    "text4": "A network error occurred. Try again later.",
    "max": "Enter 50 characters or fewer.",
    "max2": "First name must be 50 characters or fewer.",
    "katakana": "Last name (phonetic) must contain only katakana.",
    "max3": "Last name (phonetic) must be 50 characters or fewer.",
    "katakana2": "First name (phonetic) must contain only katakana.",
    "max4": "First name (phonetic) must be 50 characters or fewer.",
    "required": "Enter an email address.",
    "email2": "Enter a valid email address.",
    "max5": "Email address must be 255 characters or fewer.",
    "enqueueSnackbar": "Users with this role ({{originalNameEng}}) can't be edited on this screen.",
    "enqueueSnackbar2": "The selected role wasn't found.",
    "enqueueSnackbar3": "User information updated",
    "title": "Edit user",
    "text5": "Loading...",
    "text6": "Updating...",
    "label": "Edit",
    "title2": "Review changes",
    "text7": "Managed areas and view permissions",
    "label2": "Review",
    "label3": "Last name",
    "label4": "First name",
    "label5": "Last name (phonetic)",
    "label6": "First name (phonetic)",
    "text8": "To change the email address, go to account settings.",
    "text9": "Only the user can change their own email address."
  },
  "userFilterBar": {
    "label": "All",
    "label2": "Active",
    "label3": "Invited",
    "placeholder": "Search by email address or name",
    "label4": "Role",
    "label5": "Status",
    "button": "Invite users"
  },
  "userInviteDialog": {
    "enqueueSnackbar": "The tenant information couldn't be retrieved.",
    "enqueueSnackbar2": "The selected role wasn't found.",
    "enqueueSnackbar3": "An unexpected error occurred.",
    "title": "Invite users",
    "text": "Loading...",
    "label": "Invite",
    "label2": "Edit",
    "text2": "Email addresses (",
    "text3": ")",
    "text4": "Role",
    "text5": "Managed areas and view permissions",
    "label3": "Review",
    "label4": "Email address"
  },
  "userTable": {
    "label": "User",
    "text": "{{name}} (invited)",
    "label2": "Viewable areas/cameras",
    "text2": " areas /",
    "text3": " cameras",
    "label3": "Role"
  },
  "userTableHeader": {
    "text": " users"
  },
  "userViewLayout": {
    "text": "Deleting...",
    "title": "Delete user",
    "text2": "This action can't be undone. Continue?"
  },
  "useUserInviteForm": {
    "text": "Enter an email address."
  },
  "useUserViewState": {
    "enqueueSnackbar": "User deleted",
    "text": "The user couldn't be deleted."
  },
  "user": {
    "title": "User management"
  },
  "noPermissionWarning": {
    "text": "No view permissions are set",
    "text2": "If you select ",
    "text3": " now, this user won't be able to view any cameras.",
    "text4": "Set permissions"
  },
  "permissionEditor": {
    "text": "View permissions outside the assigned areas can't be changed on this screen."
  },
  "permissionHelp": {
    "text": "Cameras in managed areas are accessible automatically. No individual settings are needed.",
    "text2": "Outside managed areas, only the selected cameras can be viewed.",
    "text3": "With area-level permissions, cameras added later are also viewable automatically.",
    "text4": "With camera-level permissions, only the selected cameras can be viewed. Cameras added to the area later aren't included automatically."
  },
  "permissionTable": {
    "label": "View",
    "label2": "Manage",
    "ariaLabel": "Manage permission for {{name}}",
    "ariaLabel2": "View permission for {{name}}",
    "ariaLabel3": "Manage permission for {{areaName}}",
    "ariaLabel4": "View permission for {{areaName}}",
    "labelHeader": "Area / camera"
  },
  "rolePicker": {
    "sv": "Can manage all areas and cameras in the tenant",
    "areaManager": "Can manage assigned areas and view their cameras",
    "viewer": "Can view video from permitted cameras only",
    "label": "Role"
  },
  "svAutoAccessBanner": {
    "svMessage": "Administrators automatically have access to all areas and cameras in the tenant. No individual settings are needed."
  },
  "permissionBadgeStyles": {
    "label": "Manage",
    "label2": "View"
  },
  "summarizePermissions": {
    "text": "No cameras",
    "text2": "All {{totalCameras}} cameras",
    "text3": "{{selectedCount}} of {{totalCameras}} cameras"
  }
}
